(() => {
  /* delivery dates on the product page */
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w && w !== 6) n--; } return x; };
  const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const short = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const now = new Date();
  document.querySelectorAll('[data-nr-day]').forEach((el) => {
    const n = +el.dataset.nrDay;
    el.textContent = n === 0 ? fmt(now) : `by ${fmt(addBiz(now, n))}`;
  });
  document.querySelectorAll('[data-nr-range]').forEach((el) => {
    const [a, b] = el.dataset.nrRange.split(',').map(Number);
    el.textContent = `${short(addBiz(now, a))} to ${short(addBiz(now, b))}`;
  });

  /* sticky bar: shows once the main buy box is out of view, hides near the footer */
  const stick = document.querySelector('[data-nr-stick]');
  const buy = document.querySelector('[data-nr-buywrap]');
  if (stick && buy && 'IntersectionObserver' in window) {
    let buyVisible = true, footVisible = false;
    const sync = () => {
      const on = !buyVisible && !footVisible;
      stick.classList.toggle('is-on', on);
      stick.setAttribute('aria-hidden', on ? 'false' : 'true');
      stick.querySelector('a')?.setAttribute('tabindex', on ? '0' : '-1');
    };
    new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting || e.boundingClientRect.top > 0; sync(); }).observe(buy);
    const foot = document.querySelector('.nr-foot');
    if (foot) new IntersectionObserver(([e]) => { footVisible = e.isIntersecting; sync(); }).observe(foot);
  }
})();
(() => {
  /* Christmas: real shipping cutoff; switch copy once it has passed */
  const today = new Date(); today.setHours(0,0,0,0);
  const parse = (s) => { const [y,m,d] = (s||'').split('-').map(Number); return y ? new Date(y, m-1, d) : null; };
  const bar = document.querySelector('[data-nr-xmas]');
  if (bar) {
    const cut = parse(bar.dataset.cutoff), xmas = new Date(today.getFullYear(), 11, 26);
    if (cut && today > cut) {
      bar.querySelector('.nr-xmas__before').hidden = true;
      if (today < xmas) bar.querySelector('.nr-xmas__after').hidden = false; else bar.hidden = true;
    }
  }
  const box = document.querySelector('[data-nr-xmas-box]');
  if (box) {
    const cut = parse(box.dataset.cutoff);
    if (cut && today > cut) box.hidden = true;
    else if (cut) {
      const days = Math.round((cut - today) / 864e5);
      const el = box.querySelector('[data-nr-gift-days]');
      if (el && days <= 21) el.textContent = days === 0 ? ' (that’s today)' : ` (${days} day${days === 1 ? '' : 's'} from now)`;
    }
  }
})();
(() => {
  /* colour picks the variant; the set picks the quantity. Pack savings are automatic discounts in Shopify. */
  const fmt = (cents) => (window.nrRoutes?.money || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  document.querySelectorAll('[data-nr-buy]').forEach((form) => {
    const src = form.querySelector('[data-nr-variants]'); if (!src) return;
    let data = []; try { data = JSON.parse(src.textContent); } catch (e) { return; }
    const hid = form.querySelector('[data-nr-variant]'), label = form.querySelector('[data-nr-btn-price]');
    const btn = form.querySelector('[data-nr-add]'), nameEl = form.querySelector('[data-nr-colour-name]');
    const qtyEl = form.querySelector('[data-nr-qty]');
    const update = (fromUser) => {
      const c = form.querySelector('input[name="nr-colour"]:checked')?.value || '';
      const pk = form.querySelector('input[name="nr-pack"]:checked');
      const q = +(pk?.value || 1), off = +(pk?.dataset.off || 0);
      const v = data.find((x) => !c || x.c === c) || data[0];
      if (!v) return;
      const total = v.price * q - off;
      hid.value = v.id; hid.dataset.price = total;
      if (qtyEl) qtyEl.value = q;
      if (nameEl) nameEl.textContent = c;
      if (label) label.textContent = fmt(total);
      if (btn) { btn.disabled = !v.available; if (!v.available && label) label.textContent = 'sold out'; }
      if (fromUser && v.img) {
        const t = document.querySelector(`[data-nr-media="${v.img}"]`);
        if (t) t.click();
      }
    };
    form.addEventListener('input', () => update(true));
    form.addEventListener('change', () => update(false));
    update(false);
  });
})();
